import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sellsy': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M539.7 237.3c55.2 13.5 94.1 63.1 94.1 119.5 0 68-55.5 123.2-123.2 123.2h-381.2c-67.7 0-123.2-55.2-123.2-123.2 0-47.5 27.9-91 70.8-111.2-2.1-7.4-3.1-15-3.1-22.4 0-46.3 37.7-84 84-84 20.2 0 39.8 7.4 55.2 20.5 18.4-74.8 85.8-127.8 163-127.8 92.5 0 167.9 75.4 167.9 167.9 0 12.6-1.2 25.1-4.3 37.4zM199.9 401.6v-110.9c0-8.3-7-15.3-15.3-15.3h-30.9c-8.3 0-15.3 7-15.3 15.3v110.9c0 8.3 7 15.3 15.3 15.3h30.9c8.3 0 15.3-7 15.3-15.3zM289.4 401.6v-131.5c0-8.3-7-15.3-15.3-15.3h-30.9c-8.3 0-15.3 7-15.3 15.3v131.5c0 8.3 7 15.3 15.3 15.3h30.9c8.3 0 15.3-7 15.3-15.3zM378.8 401.6v-162.7c0-8.3-7-15.3-15.3-15.3h-30.9c-8.3 0-15.3 7-15.3 15.3v162.7c0 8.3 7 15.3 15.3 15.3h30.9c8.3 0 15.3-7 15.3-15.3zM465.9 401.6v-224.6c0-8.6-7-15.6-15.3-15.6h-28.5c-8.3 0-15.3 7-15.3 15.6v224.6c0 8.3 7 15.3 15.3 15.3h28.5c8.3 0 15.3-7 15.3-15.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sellsy.js
// module id = 1009
// module chunks = 0